import { Routes } from '@angular/router';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./routes/home.routes').then(m => m.homeRoutes)
  },
  {
    path: 'ai-chat',
    loadChildren: () => import('./routes/ai-chat.routes').then(m => m.aiChatRoutes)
  },
  {
    path: 'link',
    loadChildren: () => import('./routes/link-startup.routes').then(m => m.linkStartupRoutes)
  },
  {
    path: 'thank-you',
    loadComponent: () => import('./pages/thank-you-page/thank-you-page.component').then(m => m.ThankYouPageComponent),
    title: 'Thank you',
    data: {
      hideFooter: true
    }
  },
  /*{
    path: 'admin',
    loadComponent: () => import('./pages/admin-page/admin-page.component').then(m => m.AdminPageComponent),
    title: 'Admin portal',
    children: []
  },*/
  {
    path: 'portal',
    loadChildren: () => import('./routes/portal/portal.routes').then(m => m.portalRoutes),
    data: {
      hideFooter: true
    },
  },
  {
    path: 'admin',
    loadChildren: () => import('./routes/admin/admin.routes').then(m => m.adminRoutes),
    data: {
      hideFooter: true
    },
  },
  {path: '**', component: NotFoundPageComponent, title: '404 - not found'},
];
